export function isIOS() {
  const ua = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(ua);
}

export function subscribeDeviceHeading(cb) {
  function detectDirection(e) {
    let deg = null;
    if (isIOS()) {
      // iOS Safari: webkitCompassHeading (北=0, 時計回り）
      deg = e.webkitCompassHeading;
    } else {
      // Androidなど: alpha (北=0, 西=90,　南=180, 東=270)を反転して、 時計回りに変換)
      deg = 360 - e.alpha;
      if (deg === 360) deg = 0;
    }
    cb(typeof deg === "number" ? deg : null);
  }

  if (isIOS()) {
    window.addEventListener("deviceorientation", detectDirection, true);
  } else {
    window.addEventListener("deviceorientationabsolute", detectDirection, true);
  }
  // 解除用の関数を返すと便利
  return () => {
    if (isIOS()) {
      window.removeEventListener("deviceorientation", detectDirection, true);
    } else {
      window.removeEventListener(
        "deviceorientationabsolute",
        detectDirection,
        true
      );
    }
  };
}
